/* ==========================================================================
   Young Grandpa - cookie consent banner button label
   --------------------------------------------------------------------------
   Shopify's native Customer Privacy banner (#shopify-pc__banner, Admin:
   Settings > Customer Privacy > Cookie banner) renders its own button text -
   "Manage preferences" - which isn't theme content, so it can't be edited
   from a section/template. A CSS-only relabel (hide the real text, inject
   replacement via ::after) would leave the accessible name out of sync with
   what's shown, so this swaps the actual textContent instead.

   The banner is injected by Shopify's own script at an unpredictable time
   (and only for visitors in a regulated region - see assets/yg-custom.css
   section 11), so this watches for it rather than running once on load.
   ========================================================================== */

(function () {
  'use strict';

  var BUTTON_ID = 'shopify-pc__banner__btn-manage-prefs';
  var NEW_LABEL = 'Customize';

  function relabel(button) {
    var target = button.querySelector('span') || button;
    target.textContent = NEW_LABEL;
  }

  var existing = document.getElementById(BUTTON_ID);
  if (existing) {
    relabel(existing);
    return;
  }

  var observer = new MutationObserver(function () {
    var button = document.getElementById(BUTTON_ID);
    if (!button) return;
    relabel(button);
    observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
